import EpilogueEvent from "../event/EpilogueEvent";
import DashboardData from "../../dashboard/model/DashboardData";
import DashboardCumulativeDataFactory from "../../dashboard/controller/DashboardCumulativeDataFactory";
import DashboardScreenMediator from "../../dashboard/view/DashboardScreenMediator";
import DashboardCumulativeDataMediator from "../../dashboard/view/DashboardCumulativeDataMediator";

export default class EpilogueScreenMediator extends DashboardScreenMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target
     * @param {soma.EventDispatcher} dispatcher
     * @param {LayoutManager} layoutManager
     * @param {ClickEaterFactory} clickEaterFactory
     * @param {RevisableLanguagePack} languagePack
     * @param {DashboardData} dashboardData
     * @param {DashboardCumulativeDataFactory} dashboardCumulativeDataFactory 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardData, variableManager, mediatorManager, dashboardCumulativeDataFactory, saveGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager, saveGameModel);

        this._variableManager = variableManager;
        this._dashboardData = dashboardData;
        this._dashboardCumulativeDataFactory = dashboardCumulativeDataFactory;
        this._phase = 0;
        /** @type {DashboardCumulativeDataMediator[]} */
        this.cumulativeData = [];

    }

    initialize() {
        super.initialize();
        this.preventClickThrough();

        this._target.DashboardTab1.Annotation1.alpha = 1;
        this._target.DashboardTab1.Annotation2.alpha = 1;
        this._target.DashboardTab2.Annotation3.alpha = 1;
        this._target.DashboardTab2.GlobeEpilogue.alpha = 1;
        this._target.DashboardTab2.GlobeTab2.alpha = 0;

        this.cumulativeData.push(this._dashboardCumulativeDataFactory.createCumulativeData(this._target.DashboardTab1.Annotation1,
            "dashboard.cumulativeData.numberCumulativeCases",
            DashboardData.NODE_CUMULATIVE_CASES
        ));

        this.cumulativeData.push(this._dashboardCumulativeDataFactory.createCumulativeData(this._target.DashboardTab1.Annotation2,
            "dashboard.cumulativeData.numberCumulativeDeaths",
            DashboardData.NODE_CUMULATIVE_DEATHS
        ));

        this.cumulativeData.push(this._dashboardCumulativeDataFactory.createCumulativeData(this._target.DashboardTab2.Annotation3,
            "dashboard.cumulativeData.numberNonEnvd",
            DashboardData.NODE_CUMULATIVE_NON_ENVD
        ));

        this._continueButton = this.createButton(this._target.EpilogueContinueButton, this._handleContinueButton.bind(this), this._languagePack.getText('epilogue.continueButton'));
        this._backButton = this.createButton(this._target.EpilogueBackButton, this._handleBackButton.bind(this), this._languagePack.getText('epilogue.backButton'));

        this._localiseTexts();
        this._goToPhase(this._phase);
    }


    _localiseTexts() {
        this._target.DashboardTab1.LabelTab1.alpha = 0;
        this._target.DashboardTab2.LabelTab2.alpha = 0;
        this._target.DashboardTab1.LabelTab1Color.alpha = 1;
        this._target.DashboardTab2.LabelTab2Color.alpha = 1;
        this._target.DashboardTab1.LabelTab1Color.text = this._languagePack.getText(`epilogue.legend`);
        this._target.DashboardTab2.LabelTab2Color.text = this._languagePack.getText(`epilogue.legend`);
    }

    forceEpiTab() {
        this._handleTabEpiButton();
    }

    forceHealthSystemsTab() {
        this._handleTabHealthSystemsButton();
    }

    hideCumulativeData() {
        this.cumulativeData.forEach((cumulativeDataMediator) => {
            cumulativeDataMediator.hide();
        });
    }

    showCumulativeData() {
        this.cumulativeData.forEach((cumulativeDataMediator) => {
            cumulativeDataMediator.show();
        });
    }


    destroy() {
        super.destroy();
    }

    _handleBackButton() {
        this._phase = Math.max(0, this._phase - 1);
        this._goToPhase(this._phase);
    }

    _handleContinueButton() {
        this._phase = Math.min(4, this._phase + 1);
        this._goToPhase(this._phase);
    }

    /**
     * 
     * @param {number} phase 
     */
    _goToPhase(phase) {
        this._backButton.setVisible(phase > 0);

        switch (this._phase) {
            case 0:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step1');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step1');
                this.forceEpiTab();
                this.hideCumulativeData();
                break;
            case 1:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step2');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step2');
                this.forceEpiTab();
                this.showCumulativeData();
                break;
            case 2:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step3');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step3');
                this.forceHealthSystemsTab();
                this.hideCumulativeData();
                break;
            case 3:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step4');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step4');
                this.forceHealthSystemsTab();
                this.showCumulativeData();
                break;
            case 4:
                this.dispatch(EpilogueEvent.CLOSE_REQUEST);
        }
    }

    _updateTabNotifications() {
        // NB: override behaviour of updating tab notifications as this screen does not use it
    }
}